/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template "model.velocity"
 */

/**
 * THIS Template MUST remain FRAMEWORK INDEPENDENT!! It is used for Angular, Ionic, Node-Express... any JavaScript framework
 */

/* tslint:disable */


export class LitigationMotive {
    code: string; // ecf001
    name: string; // ecf001
    helpText: string; // ecf001


    // <editor-fold desc="From and To Json Methods" defaultstate="collapsed">
/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template &quot;model-json.velocity&quot;
 */

    /** ---- Generated part from .\ang-man\src\modules\generator\writers\common\templates\model-json.velocity */

    public static mergeJSON(instance: any, data: any): LitigationMotive {
        if (!data) { return instance; }
        if (data.code != null) {instance.code = data.code; }
        if (data.name != null) {instance.name = data.name; }
        if (data.helpText != null) {instance.helpText = data.helpText; }
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return LitigationMotive.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: LitigationMotive) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return LitigationMotive.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: LitigationMotive): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }

    /** ---- */


/** end of template &quot;model-json.velocity&quot; */

    // </editor-fold>

}


/** end of template "model.velocity" */
